/* encoksatan · Futurer görünümü davranışları. Bağımlılık yok. Düzenleyicide section yeniden yüklenince yeniden bağlanır. */
(function () {
  'use strict';
  var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function serit(kok) {
    var iz = kok.querySelector('[data-fx-iz]');
    if (!iz) return;
    var geri = kok.querySelector('[data-fx-geri]');
    var ileri = kok.querySelector('[data-fx-ileri]');
    var cubuk = kok.querySelector('[data-fx-cubuk]');
    function adim() {
      var ilk = iz.firstElementChild;
      return ilk ? ilk.getBoundingClientRect().width + parseFloat(getComputedStyle(iz).columnGap || 0) : iz.clientWidth;
    }
    function guncelle() {
      var maks = iz.scrollWidth - iz.clientWidth;
      if (geri) geri.disabled = iz.scrollLeft <= 2;
      if (ileri) ileri.disabled = iz.scrollLeft >= maks - 2;
      if (cubuk) {
        var oran = iz.scrollWidth ? Math.min(1, iz.clientWidth / iz.scrollWidth) : 1;
        var yol = cubuk.parentElement.clientWidth * (1 - oran);
        cubuk.style.setProperty('--fx-ilk', (oran * 100) + '%');
        cubuk.style.setProperty('--fx-x', (maks > 0 ? (iz.scrollLeft / maks) * yol : 0) + 'px');
        cubuk.parentElement.hidden = oran >= 1;
      }
    }
    if (geri) geri.addEventListener('click', function () { iz.scrollBy({ left: -adim(), behavior: azHareket ? 'auto' : 'smooth' }); });
    if (ileri) ileri.addEventListener('click', function () { iz.scrollBy({ left: adim(), behavior: azHareket ? 'auto' : 'smooth' }); });
    iz.addEventListener('scroll', guncelle, { passive: true });
    window.addEventListener('resize', guncelle);
    guncelle();
  }

  function hero(kok) {
    var slaytlar = kok.querySelectorAll('[data-fx-slayt]');
    var noktalar = kok.querySelectorAll('[data-fx-nokta]');
    var dur = kok.querySelector('[data-fx-dur]');
    if (slaytlar.length < 2) return;
    var i = 0, zaman = null, sure = (parseInt(kok.dataset.sure, 10) || 0) * 1000, durdu = azHareket;
    function goster(n) {
      i = (n + slaytlar.length) % slaytlar.length;
      slaytlar.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      noktalar.forEach(function (d, k) { d.classList.toggle('is-on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function baslat() { clearInterval(zaman); if (sure && !durdu) zaman = setInterval(function () { goster(i + 1); }, sure); }
    noktalar.forEach(function (d) { d.addEventListener('click', function () { goster(parseInt(d.dataset.fxNokta, 10)); baslat(); }); });
    if (dur) {
      dur.setAttribute('aria-pressed', durdu ? 'true' : 'false');
      dur.addEventListener('click', function () { durdu = !durdu; dur.setAttribute('aria-pressed', durdu ? 'true' : 'false'); baslat(); });
    }
    kok.addEventListener('mouseenter', function () { clearInterval(zaman); });
    kok.addEventListener('mouseleave', baslat);
    baslat();
  }

  function vitrin(kok) {
    var adlar = kok.querySelectorAll('[data-fx-vit-ad]');
    var paneller = kok.querySelectorAll('[data-fx-vit-panel]');
    var iz = kok.querySelector('[data-fx-vit-iz]');
    if (!adlar.length) return;
    var i = 0, zaman = null, sure = (parseInt(kok.dataset.sure, 10) || 0) * 1000;
    function goster(n, odak) {
      i = (n + adlar.length) % adlar.length;
      adlar.forEach(function (a, k) { a.classList.toggle('is-on', k === i); a.setAttribute('aria-selected', k === i ? 'true' : 'false'); a.tabIndex = k === i ? 0 : -1; });
      paneller.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.hidden = k !== i; });
      var a = adlar[i], kap = iz.parentElement;
      var hedef = a.offsetLeft - (kap.clientWidth - a.offsetWidth) / 2;
      var maks = Math.max(0, iz.scrollWidth - kap.clientWidth);
      iz.style.transform = 'translateX(' + (-Math.max(0, Math.min(hedef, maks))) + 'px)';
      if (odak) a.focus();
    }
    function baslat() { clearInterval(zaman); if (sure && !azHareket) zaman = setInterval(function () { goster(i + 1); }, sure); }
    adlar.forEach(function (a, k) {
      a.addEventListener('click', function () { goster(k); baslat(); });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goster(i + 1, true); baslat(); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { goster(i - 1, true); baslat(); e.preventDefault(); }
      });
    });
    kok.addEventListener('mouseenter', function () { clearInterval(zaman); });
    kok.addEventListener('mouseleave', baslat);
    window.addEventListener('resize', function () { goster(i); });
    goster(0);
    baslat();
  }

  function para(kurus, bicim) {
    var m = (bicim || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var tur = m ? m[1] : 'amount';
    var n = (kurus / 100);
    var s;
    if (tur === 'amount_no_decimals') s = Math.round(n).toLocaleString('en-US');
    else if (tur === 'amount_with_comma_separator') s = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else if (tur === 'amount_no_decimals_with_comma_separator') s = Math.round(n).toLocaleString('de-DE');
    else s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (bicim || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]*>/g, '');
  }

  function combo(kok) {
    var btn = kok.querySelector('[data-fx-combo-ekle]');
    if (!btn) return;
    var secimler = kok.querySelectorAll('[data-fx-combo-secim]');
    var toplamEl = kok.querySelector('[data-fx-combo-toplam]');
    var eskiEl = kok.querySelector('[data-fx-combo-eski]');
    var durum = kok.querySelector('[data-fx-combo-durum]');
    var bicim = btn.dataset.bicim;
    function veri(el) { return el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el; }
    function topla() {
      var t = 0, e = 0;
      secimler.forEach(function (el) { var d = veri(el); t += parseInt(d.dataset.fiyat, 10) || 0; e += parseInt(d.dataset.eski, 10) || 0; });
      toplamEl.textContent = para(t, bicim);
      eskiEl.textContent = para(e, bicim);
      eskiEl.hidden = e <= t;
    }
    secimler.forEach(function (el) { if (el.tagName === 'SELECT') el.addEventListener('change', topla); });
    btn.addEventListener('click', function () {
      var items = [];
      secimler.forEach(function (el) { items.push({ id: parseInt(el.value, 10), quantity: 1 }); });
      btn.disabled = true; durum.textContent = '';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (s) {
          if (!s.ok) throw new Error(s.j && (s.j.description || s.j.message) || 'Sepete eklenemedi');
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (err) { durum.textContent = err.message || 'Sepete eklenemedi, tekrar deneyin.'; btn.disabled = false; });
    });
    topla();
  }

  function yorum(kok) {
    var av = kok.querySelectorAll('[data-fx-yorum-avatar]');
    var bal = kok.querySelectorAll('[data-fx-yorum-balon]');
    if (!av.length) return;
    var i = 0;
    function goster(n) {
      i = (n + av.length) % av.length;
      av.forEach(function (a, k) { a.classList.toggle('is-on', k === i); });
      bal.forEach(function (b, k) { b.hidden = k !== i; b.classList.toggle('is-on', k === i); });
    }
    av.forEach(function (a, k) { a.addEventListener('click', function () { goster(k); }); });
    var g = kok.querySelector('[data-fx-yorum-geri]'), il = kok.querySelector('[data-fx-yorum-ileri]');
    if (g) g.addEventListener('click', function () { goster(i - 1); });
    if (il) il.addEventListener('click', function () { goster(i + 1); });
  }

  function bagla(alan) {
    alan.querySelectorAll('[data-fx-serit]').forEach(serit);
    alan.querySelectorAll('[data-fx-hero]').forEach(hero);
    alan.querySelectorAll('[data-fx-vitrin]').forEach(vitrin);
    alan.querySelectorAll('[data-fx-combo]').forEach(combo);
    alan.querySelectorAll('[data-fx-yorum]').forEach(yorum);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bagla(document); });
  else bagla(document);
  document.addEventListener('shopify:section:load', function (e) { bagla(e.target); });
})();
